// Fournisseur d'authentification simple pour MyAdmin
export const authProvider = {
  // Connexion
  login: ({ username, password }) => {
    if (username === 'Jmaudet' && password === 'mjerome2000') {
      localStorage.setItem('auth', JSON.stringify({ username, role: 'admin' }));
      return Promise.resolve();
    }
    return Promise.reject(new Error('Nom d\'utilisateur ou mot de passe incorrect'));
  },

  // Déconnexion
  logout: () => {
    localStorage.removeItem('auth');
    return Promise.resolve();
  },

  // Vérification de l'authentification
  checkAuth: () => {
    const auth = localStorage.getItem('auth');
    return auth ? Promise.resolve() : Promise.reject();
  },

  // Vérification des erreurs d'authentification
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  // Obtenir les permissions
  getPermissions: () => {
    const auth = localStorage.getItem('auth');
    if (auth) {
      const { role } = JSON.parse(auth);
      return Promise.resolve(role);
    }
    return Promise.reject();
  },

  // Obtenir l'identité de l'utilisateur
  getIdentity: () => {
    const auth = localStorage.getItem('auth');
    if (auth) {
      const { username } = JSON.parse(auth);
      return Promise.resolve({
        id: username,
        fullName: 'Administrateur',
        avatar: null,
      });
    }
    return Promise.reject();
  },
};